import DataStructure, { sanitize } from "./DataStructure.js";
import { deepFreeze } from "../util/misc.js";
import { compact } from "lodash";

export const ITEM_FIELDS = {
  brand: "",
  series: "",
  material: "",
  type: "",
};
deepFreeze(ITEM_FIELDS);

export const MATERIALS = [
  "Aluminum",
  "Clad/Wood",
  "Fiberglass",
  "Steel",
  "Vinyl",
  "Wood",
];
deepFreeze(MATERIALS);

export const ITEM_TYPES = ["Doors", "Garage Doors", "Skylights", "Windows"];
deepFreeze(ITEM_TYPES);

export default class LeadItem extends DataStructure {
  constructor(data = {}) {
    super(sanitize(data, ITEM_FIELDS));
  }

  // Editing

  get isValid() {
    return Boolean(this.data.brand || this.data.type);
  }

  // Formatting

  toString() {
    return compact([
      this.data.brand,
      this.data.series,
      this.data.material,
      this.data.type,
    ]).join(" ");
  }
}
